import { render } from "./CopyableTeamEmail.vue?vue&type=template&id=f0ea5852&scoped=true"
import script from "./CopyableTeamEmail.vue?vue&type=script&lang=js"
export * from "./CopyableTeamEmail.vue?vue&type=script&lang=js"

import "./CopyableTeamEmail.vue?vue&type=style&index=0&id=f0ea5852&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f0ea5852"

export default script